module.exports = __webpack_public_path__ + "static/media/encoding_partners.456a9bea.svg";